'use client';
import { SportMatchModel } from '@nf/types/odds';
import { useLiveTimer } from '@/features/odds-page/hooks/use-live-timer';
import { LiveTimer } from '@nf/types/live-timer';
import { useTranslations } from 'next-intl';

export const MatchLiveTimer = ({ match }: { match: SportMatchModel }) => {
	const { GameID } = match ?? {};
	const t = useTranslations('General');
	const liveTimer: LiveTimer = useLiveTimer(match);
	const isShowMatchStatus = liveTimer.matchStatus && !liveTimer.countdownDomRef;
	const isEsport = (GameID === 43);
	return (
		<>
			{
				isShowMatchStatus ? (
					<div className="select-match-item__time">{isEsport ? liveTimer.matchStatus : t('lbl_live') }</div>
				) : (
					<div className="select-match-item__time" ref={liveTimer.countdownDomRef} />
				)
			}
		</>
	);
};
